import { $$, html, text } from './modules/dom';

const slugify = (s) => s.toLowerCase().replaceAll(/\s+/g, '-');

const kitUrl = (name) => `${window.location.origin}/starter-kits/${name}.tgz`;

const curlCommand = (name) => `curl ${kitUrl(name)} | tar xzf -`;

const showClick = (icon) => {
  const { top, left } = icon.getBoundingClientRect();
  const fill = icon.style.fill;
  icon.style.position = 'relative';
  icon.style.fill = '#111';
  icon.style.top = '2px';
  icon.style.left = '2px';
  setTimeout(() => {
    icon.style.fill = fill;
    icon.style.position = 'static';
  }, 150);
};

$$('.to-clipboard').forEach((element) => {
  const toCopy = curlCommand(slugify(element.querySelector('span').innerText));
  const icon = html(
    '<svg class="bi" fill="#333"><use xlink:href="/img/bootstrap-icons.svg#clipboard"/></svg>',
  );
  icon.onclick = () => {
    navigator.clipboard.writeText(toCopy);
    showClick(icon);
  };
  element.append(text(' '));
  element.append(icon);
});
